/* eslint-disable */

import "./mainToggler.scss";

const MainToggler = (props) => {
  const {
    uniqueName,
    toggleValue,
    setIsToggled,
    changeToggleDisplayed,
    togglerHeadings,
  } = props;

  return (
    <div className="main_toggler">
      {togglerHeadings.map((item, index) => (
        <div className={`main_toggler_value ${toggleValue === item.value ? "main_toggler_value_active" : ""}`} key={`${uniqueName}_${index}`}>
          <p onClick={() => setIsToggled(item.value)}>{item.heading}</p>
        </div>
      ))}
    </div>
  );
};

export default MainToggler;
